module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-pos-r",
    attrs: {
      "id": "app"
    }
  }, [(_vm.swipe.show) ? _c('sq-swipe', {
    attrs: {
      "data": _vm.swipe
    }
  }) : _vm._e(), _vm._v(" "), _c('sq-header'), _vm._v(" "), _c('sq-content'), _vm._v(" "), _c('sq-footer'), _vm._v(" "), _c('sq-comment-area'), _vm._v(" "), _c('sq-func-buttons'), _vm._v(" "), _c('sq-share')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-697945fc"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 209
// module chunks = 1